import { useQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'

async function getPlan() {
  const response = await client.get(`/plans/subscription/category/BASE`)
  return response[0]
}

const useGetPlan = (config = {}) => {
  const { isLoading, data } = useQuery({
    queryKey: ['plan'],
    queryFn: () => getPlan(),
    staleTime: 30000,
    enabled: true,
    refetchOnWindowFocus: false,
    ...config
  })

  return { isLoading, data }
}

export default useGetPlan
